const getOrders = state => state.orders;

export default {
  getOrders,
};



// WEBPACK FOOTER //
// ./src/store/modules/orders/getters.js